"use client";

/**
 * 404 - follows the Round 10 error-state anatomy: plain heading that
 * names the fact, one sentence of cause (a stale listing link is the
 * common case here), the way out as the single indigo action, and a
 * quiet gray status code. Left-aligned, with the searching figure
 * beside the text (owner asked for the illustration back, larger). Trilingual via the locale context (this file
 * lives under [locale], so the provider wraps it).
 */
import Link from "@/lib/localized-link";
import { useT } from "@/lib/locale-context";
import { NotFoundScene } from "@/components/animations/SceneAnimations";

export default function NotFound() {
  const t = useT();
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="w-full max-w-2xl rounded-2xl border border-gray-200 bg-white p-8 sm:p-12">
        <div className="flex flex-col-reverse gap-8 sm:flex-row sm:items-center sm:justify-between">
          <div className="min-w-0">
            <div className="text-[13px] font-semibold text-gray-400 tabular-nums">404</div>
            <h1 className="mt-3 text-2xl sm:text-3xl font-extrabold tracking-tight leading-[1.15] text-gray-900">
              {t("notfound.title")}
            </h1>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-gray-600">
              {t("notfound.body")}
            </p>
            <div className="mt-6">
              <Link
                href="/"
                className="inline-flex rounded-xl bg-indigo-600 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-indigo-700"
              >
                {t("notfound.home")}
              </Link>
            </div>
          </div>
          <div className="h-52 w-64 shrink-0 self-center sm:h-60 sm:w-[300px]">
            <NotFoundScene />
          </div>
        </div>
      </div>
    </div>
  );
}
